// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   VStack,
//   Flex,
//   Text,
//   Select,
//   Spinner,
//   Td,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Badge,
//   Checkbox,
//   Button,
//   Stack,
//   Input,
//   IconButton,
//   useToast,
//   Center,
// } from "@chakra-ui/react";
// import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
// import EditFeeModal from "./EditFeeModal"; // Import the modal component
// import { BASE_URL } from "../../../Globalapi/Globalapi";
// const FeesGroupTable = () => {
//   const [studentFees, setStudentFees] = useState([]);
//   const [feeTypes, setFeeTypes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(50);
//   const [searchOption, setSearchOption] = useState("");
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [feeData, setFeeData] = useState(null);
//   const toast = useToast();

//   useEffect(() => {
//     fetchStudentFees();
//   }, []);

//   const refreshData = () => {
//     // After editing the fee group, refresh the fee groups list
//     fetchStudentFees();
//   };

//   const fetchStudentFees = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(
//         `${BASE_URL}/admin/Fees/fees_view/admin_full.php`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             org_id: sessionStorage.getItem("cmp_id"),
//             user_id: sessionStorage.getItem("user_id"),
//           }),
//         }
//       );

//       const result = await response.json();
//       console.log(result);

//       if (result.success) {
//         setStudentFees(result.fee_records); //tbl_student_fees
//         // setFeeTypes(result.data.tbl_fee_types_in_master);
//       } else {
//         toast({
//           title: "Error",
//           description: result.message,
//           status: "error",
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     } catch (error) {
//       toast({
//         title: "Error",
//         description: "Unable to fetch data. Please try again later.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Filter data based on search term (now using 'class_id' instead of 'group_name')
//   // Filter data based on search term
//   const filteredStudentFees = studentFees.filter((fee) => {
//     if (!searchOption || !searchTerm.trim()) return true; // If no filter is applied, return all

//     const normalizedSearchTerm = searchTerm.trim().toLowerCase(); // Normalize search term

//     switch (searchOption) {
//       case "class_id":
//         return fee.class_id
//           ?.toString()
//           .toLowerCase()
//           .includes(normalizedSearchTerm);
//       case "student_name":
//         return fee.student_id?.toLowerCase().includes(normalizedSearchTerm);
//       case "start_date":
//         return fee.start_date?.toLowerCase().includes(normalizedSearchTerm);
//       default:
//         return true;
//     }
//   });

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };

//   // Pagination logic
//   const indexOfLastRow = currentPage * rowsPerPage;
//   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//   const currentData = filteredStudentFees.slice(
//     indexOfFirstRow,
//     indexOfLastRow
//   );
//   const totalPages = Math.ceil(filteredStudentFees.length / rowsPerPage);

//   const handleEdit = async (feeId, studentId) => {
//     try {
//       const response = await fetch(
//         `${BASE_URL}/admin/Fees/fees_view/user_view_admin.php`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             org_id: sessionStorage.getItem("cmp_id"), // Pass the org_id
//             student_id: studentId, // Pass the student_id
//           }),
//         }
//       );

//       const result = await response.json();

//       if (result.success) {
//         setFeeData(result.data.tbl_student_fees[0]); // Set the fee data to display in modal
//         setIsModalOpen(true); // Open the modal
//       } else {
//         toast({
//           title: "Error",
//           description: result.message,
//           status: "error",
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     } catch (error) {
//       toast({
//         title: "Error",
//         description: "Unable to fetch data. Please try again later.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   };

//   // Handle Delete Action
//   // Handle Delete Action
//   const handleDelete = async (feeId, studentId) => {
//     try {
//       const response = await fetch(
//         "${BASE_URL}/admin/Fees/fees_view/delete_fee_student.php", // Correct API endpoint
//         {
//           method: "DELETE", // Ensure we're using the DELETE method
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             id: feeId, // Pass 'id' as feeId
//             student_id: studentId, // Pass 'student_id' as studentId
//           }),
//         }
//       );

//       const result = await response.json(); // Parse the response from the server

//       console.log("====================================");
//       console.log(result); // Log the result for debugging purposes
//       console.log("====================================");

//       if (result.success) {
//         // Remove the deleted fee from the local state
//         setStudentFees(studentFees.filter((fee) => fee.id !== feeId));

//         toast({
//           title: "Success",
//           description: result.message,
//           status: "success",
//           duration: 3000,
//           isClosable: true,
//         });
//       } else {
//         toast({
//           title: "Error",
//           description: result.message,
//           status: "error",
//           duration: 3000,
//           isClosable: true,
//         });
//       }
//     } catch (error) {
//       console.error("Delete error:", error); // Log the error for debugging
//       toast({
//         title: "Error",
//         description: "Unable to delete. Please try again later.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//     }
//   };

//   return (
//     <Box p={6} maxWidth="100%" overflowX="auto">
//       <Flex
//         direction="row"
//         justify="space-between"
//         className="sb"
//         mb={1}
//         p={4}
//         align="center"
//       >
//         <Flex align="center">
//           <Text mr={2}>Rows Per Page</Text>
//           <Select
//             value={rowsPerPage}
//             onChange={(e) => setRowsPerPage(Number(e.target.value))}
//             width="100px"
//           >
//             <option value={50}>50</option>
//             <option value={70}>70</option>
//             <option value={100}>100</option>
//           </Select>
//         </Flex>

//         <Flex align="center" justify="space-between">
//           <Select
//             placeholder="Select Search Field"
//             value={searchOption}
//             onChange={(e) => setSearchOption(e.target.value)}
//             width="200px"
//             mr={4}
//           >
//             <option value="student_name">Student Name</option>
//             <option value="class_id">Class</option>
//             <option value="start_date">Start Date</option>
//           </Select>

//           <Input
//             placeholder={`Search by ${searchOption || "Select a field"}`}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             width="300px"
//           />
//         </Flex>
//       </Flex>

//       <Box borderWidth="1px" borderRadius="md" overflow="hidden">
//         <Table
//           sx={{
//             "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
//           }}
//         >
//           <Thead>
//             <Tr>
//               <Th>Class </Th>
//               <Th>Student </Th>
//               <Th>Start Date</Th>
//               <Th>Due Date</Th>
//               <Th>Amount</Th>
//               <Th textAlign="center">Fine Amount</Th>
//               <Th>
//                 <Box textAlign="center">Discount Amount</Box>
//               </Th>
//               <Th>Total Amount</Th>
//               <Th>Payment Status</Th>
//               <Th>Payment Method</Th>
//               {/* <Th>Actions</Th> */}
//             </Tr>
//           </Thead>
//           <Tbody>
//             {loading ? (
//               <Tr>
//                 <Td colSpan={7} textAlign="center">
//                   <Spinner size="xl" />
//                 </Td>
//               </Tr>
//             ) : currentData.length > 0 ? (
//               currentData.map((fee) => (
//                 <Tr key={fee.fee_id}>
//                   <Td>{fee.class_id}</Td>
//                   <Td>{fee.student_id}</Td>
//                   <Td>{fee.start_date}</Td>
//                   <Td>{fee.due_date}</Td>
//                   <Td>{fee.total_amount_with_discount}</Td>
//                   <Td>
//                     <Box textAlign="right">{fee.fine_amount} </Box>
//                   </Td>
//                   <Td>
//                     <Box textAlign="right">{fee.discount} </Box>
//                   </Td>
//                   <Td>
//                     <Box textAlign="right">{fee.t_total}</Box>
//                   </Td>
//                   <Td>
//                     <Box textAlign="center">
//                       <Badge
//                         textAlign="center"
//                         borderRadius="full"
//                         fontSize="x-small"
//                         colorScheme={
//                           fee.payment_status === "paid" ? "green" : "red"
//                         }
//                       >
//                         {fee.payment_status}
//                       </Badge>
//                     </Box>
//                   </Td>
//                   <Td>
//                     {fee.payment_method === 1
//                       ? "Cash"
//                       : fee.payment_method === 2
//                       ? "Online"
//                       : "Not Paid"}
//                   </Td>

//                   {/* <Td>
//                     <IconButton
//                       icon={<EditIcon />}
//                       colorScheme="blue"
//                       size="sm"
//                       onClick={() => handleEdit(fee.fee_id, fee.std_id)} aria-label="Edit"
//                     />
//                     <IconButton
//                       icon={<DeleteIcon />}
//                       colorScheme="red"
//                       size="sm"
//                       ml={2}
//                       onClick={() => handleDelete(fee.fee_id, fee.std_id)}
//                       aria-label="Delete"
//                     />
//                   </Td> */}
//                 </Tr>
//               ))
//             ) : (
//               <Tr>
//                 <Td colSpan={7} textAlign="center">
//                   No data found.
//                 </Td>
//               </Tr>
//             )}
//           </Tbody>
//         </Table>
//       </Box>

//       {/* Pagination */}
//       <Flex justify="end" align="center" mt={4}>
//         <Button
//           onClick={() => handlePageChange(currentPage - 1)}
//           isDisabled={currentPage === 1}
//         >
//           Prev
//         </Button>

//         <Stack direction="row" spacing={2} mx={2}>
//           {Array.from({ length: totalPages }, (_, i) => (
//             <Button
//               key={i}
//               onClick={() => handlePageChange(i + 1)}
//               colorScheme={currentPage === i + 1 ? "teal" : "gray"}
//             >
//               {i + 1}
//             </Button>
//           ))}
//         </Stack>

//         <Button
//           onClick={() => handlePageChange(currentPage + 1)}
//           isDisabled={currentPage === totalPages}
//         >
//           Next
//         </Button>
//       </Flex>

//       {/* Edit Modal */}
//       {feeData && (
//         <EditFeeModal
//           isOpen={isModalOpen}
//           onClose={() => setIsModalOpen(false)}
//           feeData={feeData}
//           refreshData={refreshData}
//         />
//       )}
//     </Box>
//   );
// };

// export default FeesGroupTable;

import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Flex,
  Text,
  Select,
  Spinner,
  Td,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Badge,
  Checkbox,
  Button,
  Stack,
  Input,
  IconButton,
  useToast,
  Center,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import EditFeeModal from "./EditFeeModal"; // Import the modal component
import { BASE_URL } from "../../../Globalapi/Globalapi";
const FeesGroupTable = () => {
  const [studentFees, setStudentFees] = useState([]);
  const [feeTypes, setFeeTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchOption, setSearchOption] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feeData, setFeeData] = useState(null);
  const toast = useToast();

  useEffect(() => {
    fetchStudentFees();
  }, []);

  const refreshData = () => {
    // After editing the fee group, refresh the fee groups list
    fetchStudentFees();
  };

  const fetchStudentFees = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_URL}/admin/Fees/fees_view/admin_full.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: sessionStorage.getItem("cmp_id"),
            user_id: sessionStorage.getItem("user_id"),
          }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.success) {
        setStudentFees(result.fee_records); //tbl_student_fees
        // setFeeTypes(result.data.tbl_fee_types_in_master);
      } else {
        toast({
          title: "Error",
          description: result.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Unable to fetch data. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // Filter data based on search term (now using 'class_id' instead of 'group_name')
  // Filter data based on search term
  const filteredStudentFees = studentFees.filter((fee) => {
    if (!searchOption || !searchTerm.trim()) return true; // If no filter is applied, return all

    const normalizedSearchTerm = searchTerm.trim().toLowerCase(); // Normalize search term

    switch (searchOption) {
      case "class_id":
        return fee.class_id
          ?.toString()
          .toLowerCase()
          .includes(normalizedSearchTerm);
      case "student_name":
        return fee.student_id?.toLowerCase().includes(normalizedSearchTerm);
      case "start_date":
        return fee.start_date?.toLowerCase().includes(normalizedSearchTerm);
      default:
        return true;
    }
  });

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredStudentFees.slice(
    indexOfFirstRow,
    indexOfLastRow
  );
  const totalPages = Math.ceil(filteredStudentFees.length / rowsPerPage);

  const handleEdit = async (feeId, studentId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/Fees/fees_view/user_view_admin.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            org_id: sessionStorage.getItem("cmp_id"), // Pass the org_id
            student_id: studentId, // Pass the student_id
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        setFeeData(result.data.tbl_student_fees[0]); // Set the fee data to display in modal
        setIsModalOpen(true); // Open the modal
      } else {
        toast({
          title: "Error",
          description: result.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Unable to fetch data. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Handle Delete Action
  // Handle Delete Action
  const handleDelete = async (feeId, studentId) => {
    try {
      const response = await fetch(
        "${BASE_URL}/admin/Fees/fees_view/delete_fee_student.php", // Correct API endpoint
        {
          method: "DELETE", // Ensure we're using the DELETE method
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: feeId, // Pass 'id' as feeId
            student_id: studentId, // Pass 'student_id' as studentId
          }),
        }
      );

      const result = await response.json(); // Parse the response from the server

      console.log("====================================");
      console.log(result); // Log the result for debugging purposes
      console.log("====================================");

      if (result.success) {
        // Remove the deleted fee from the local state
        setStudentFees(studentFees.filter((fee) => fee.id !== feeId));

        toast({
          title: "Success",
          description: result.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: result.message,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Delete error:", error); // Log the error for debugging
      toast({
        title: "Error",
        description: "Unable to delete. Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={6} maxWidth="100%" overflowX="auto">
      <Flex
        // direction="row"
        // justify="space-between"
        // className="sb"
        // mb={1}
        // p={4}
        // align="center"
        justify="space-between"
        borderRadius={5}
        className="sb"
        mb={1}
        p={3}
        align="center"
        direction={{ base: "column", md: "row" }}
        gap={4} // add spacing between children
        w="100%"
      >
        <Flex align="center" w={{ base: "100%", md: "auto" }}>
          <Text mr={2}>Rows Per Page</Text>
          <Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            width="100px"
          >
            <option value={50}>50</option>
            <option value={70}>70</option>
            <option value={100}>100</option>
          </Select>
        </Flex>

        <Flex
          align="center"
          justify="space-between"
          w={{ base: "100%", md: "auto" }}
        >
          <Select
            placeholder="Select Search Field"
            value={searchOption}
            onChange={(e) => setSearchOption(e.target.value)}
            width="200px"
            mr={4}
          >
            <option value="student_name">Student Name</option>
            <option value="class_id">Class</option>
            <option value="start_date">Start Date</option>
          </Select>

          <Input
            placeholder={`Search by ${searchOption || "Select a field"}`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            width="300px"
          />
        </Flex>
      </Flex>

      <Box borderWidth="1px" borderRadius="md" overflow="auto">
        <Table
          sx={{
            "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
          }}
        >
          <Thead>
            <Tr>
              <Th>Class </Th>
              <Th>Student </Th>
              <Th>Start Date</Th>
              <Th>Due Date</Th>
              <Th>Amount</Th>
              <Th textAlign="center">Fine Amount</Th>
              <Th>
                <Box textAlign="center">Discount Amount</Box>
              </Th>
              <Th>Total Amount</Th>
              <Th>Payment Status</Th>
              <Th>Payment Method</Th>
              {/* <Th>Actions</Th> */}
            </Tr>
          </Thead>
          <Tbody>
            {loading ? (
              <Tr>
                <Td colSpan={7} textAlign="center">
                  <Spinner size="xl" />
                </Td>
              </Tr>
            ) : currentData.length > 0 ? (
              currentData.map((fee) => (
                <Tr key={fee.fee_id}>
                  <Td>{fee.class_id}</Td>
                  <Td>{fee.student_id}</Td>
                  <Td>{fee.start_date}</Td>
                  <Td>{fee.due_date}</Td>
                  <Td>{fee.total_amount_with_discount}</Td>
                  <Td>
                    <Box textAlign="right">{fee.fine_amount} </Box>
                  </Td>
                  <Td>
                    <Box textAlign="right">{fee.discount} </Box>
                  </Td>
                  <Td>
                    <Box textAlign="right">{fee.t_total}</Box>
                  </Td>
                  <Td>
                    <Box textAlign="center">
                      <Badge
                        textAlign="center"
                        borderRadius="full"
                        fontSize="x-small"
                        colorScheme={
                          fee.payment_status === "paid" ? "green" : "red"
                        }
                      >
                        {fee.payment_status}
                      </Badge>
                    </Box>
                  </Td>
                  <Td>
                    {fee.payment_method === 1
                      ? "Cash"
                      : fee.payment_method === 2
                      ? "Online"
                      : "Not Paid"}
                  </Td>

                  {/* <Td>
                    <IconButton
                      icon={<EditIcon />}
                      colorScheme="blue"
                      size="sm"
                      onClick={() => handleEdit(fee.fee_id, fee.std_id)} aria-label="Edit"
                    />
                    <IconButton
                      icon={<DeleteIcon />}
                      colorScheme="red"
                      size="sm"
                      ml={2}
                      onClick={() => handleDelete(fee.fee_id, fee.std_id)}
                      aria-label="Delete"
                    />
                  </Td> */}
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7} textAlign="center">
                  No data found.
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Box>

      {/* Pagination */}
      <Flex justify="end" align="center" mt={4}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>

        <Stack direction="row" spacing={2} mx={2}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              colorScheme={currentPage === i + 1 ? "teal" : "gray"}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>

        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      {/* Edit Modal */}
      {feeData && (
        <EditFeeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          feeData={feeData}
          refreshData={refreshData}
        />
      )}
    </Box>
  );
};

export default FeesGroupTable;
